import React ,{useState} from "react";
import ReactECharts from "echarts-for-react";
import dropicon from  "../../../../../../../../Assets/AppComponent/Customersupport_icon/Draganddropicon.svg"
import boximg from "../../../../../../../../Assets/AppComponent/Group 427320177.svg";

export const CommonCharts = ({ title, data ,selectedFilter, setSelectedFilter }) => {
const donutChartOptions = {
  tooltip: {
    trigger: "item",
    formatter: (params) => {
      const value = data.find(
        (d) => d.name === params.name
      )?.value;
      return `${params.name}: ${value}%`;
    },
  },
  legend: {
    orient: "vertical",
    right: 0,
    top: "center",
    itemWidth: 10,
    itemHeight: 10,
    itemGap: 30,
formatter: (name) => {
  const maxLength = 20;
  const displayName = name.length > maxLength ? name.slice(0, maxLength) + "..." : name;
  const item = data.slice(0, 5).find((d) => d.name === name);
  return item
    ? `{a|${displayName}}  {b|${parseFloat(item.value).toFixed(2)}%}`
    : displayName;
},
    textStyle: {
      rich: {
        a: {
          fontSize: 13,
          color: "#333",
          width: 190,
          padding: [0, 5, 0, 10],
        },
        b: {
          fontSize: 13,
          color: "#234492",
        },
      },
    },
  },
  color: ["#234492", "#F99D1C", "#2F3C91", "#66D19E", "#4EC0CA"],
  series: [
    {
      name: "Issues",
      type: "pie",
      radius: ["45%", "85%"],
      center: ["25%", "50%"],
      avoidLabelOverlap: false,
      label: { show: false },
      labelLine: { show: false },
      itemStyle: {
        borderColor: "#fff",
        borderWidth: 3,
        borderRadius: 10,
      },
      data: data.slice(0, 5), // 👈 Limit to 5 items
    },
  ],
};


  const [showDropdown, setShowDropdown] = useState(false);
  // const [selectedFilter, setSelectedFilter] = useState("Week");

  const options = ["This Week", "This Month", "This Year"];

  const handleSelect = (option) => {
    setSelectedFilter(option.split(" ")[1]); // Sets "Week", "Month", etc.
    setShowDropdown(false);
  };



  return (
    <div className="top-issues-chart filter-dropdown">
      <div className="chart-header">
        <h3>{title}</h3>

      </div>
           {data?.length > 0 ? (
  <ReactECharts
    option={donutChartOptions}
    className="echarts-container"
    style={{ width: 620, height: "80%" }}
  />
) : (
  <div className="Dusbinbacktabls" style={{height:"387px"}}>
    <div>
      <img src={boximg} />
      <p className="text-center">No Data Available</p>
    </div>
  </div>
)}
    </div>
  );
};
